import React from "react";
import SlicerC from "../../slider";
import FilterMobileOptions from "../../Filter-mobile-buttons";
import styles from "./index.module.scss";
import { useSearchParams } from "react-router-dom";
import ButtonC from "../../button";
import { useTotalAcctCount } from "../../../../hooks/react-query/properties/useTotalAcctCount";

export default function FiltersComponent({
  setShowFilter,
  closeModal
}: {
  setShowFilter?: React.Dispatch<React.SetStateAction<boolean>>;
  closeModal?: () => void;
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const showIEButton = searchParams.get("showIEButton") ?? "true";
  const [myAccountValue, setMyAccountValue] = React.useState(
    searchParams.get("view") === "ALL ACCOUNTS" && showIEButton === "true"
      ? "ALL ACCOUNTS"
      : "MY ACCOUNTS"
  );
  const [accountTypeValue, setAccountTypeValue] = React.useState(
    searchParams.get("acctType") || "FT VERIFIED"
  );
  const [checkoutStatus, setCheckoutStatus] = React.useState(
    searchParams.get("checkoutStatus") || "ALL"
  );
  const [values, setValues] = React.useState(() => {
    return Number(searchParams.get("radius")) || 60;
  });
  const [isAllRadius, setIsAllRadius] = React.useState(() => {
    return searchParams.get("shouldIgnoreRadius") === "false"
      ? false
      : true || true;
  });
  const [orderValue, setOrderValue] = React.useState(
    searchParams.get("order") || searchParams.get("orderEmail") || "Low to High"
  );
  const [sortBy, setSortBy] = React.useState<"interest" | "email">(
    searchParams.get("orderEmail") ? "email" : "interest"
  );
  // const [showOtherVaults, setShowOtherVaults] = React.useState(
  //   searchParams.get("showOtherVaults") || "OFF"
  // );

  const { data } = useTotalAcctCount(
    myAccountValue,
    accountTypeValue,
    checkoutStatus
  );

  const handleSliderChange = (value: number) => {
    setIsAllRadius(false);
    setValues(value);
  };

  const handleAllRadiusClick = () => {
    setIsAllRadius(!isAllRadius);
    if (!isAllRadius) {
      setValues(60); // Reset to default value when enabling All
    }
  };

  const handleApply = async () => {
    const updatedParams = new URLSearchParams(searchParams);

    if (isAllRadius) {
      updatedParams.set("shouldIgnoreRadius", "true");
      updatedParams.delete("radius");
    } else {
      updatedParams.set("radius", values.toString());
      updatedParams.set("shouldIgnoreRadius", "false");
    }

    if (myAccountValue?.length > 0) {
      updatedParams.set("view", myAccountValue);
    }
    if (accountTypeValue?.length > 0) {
      updatedParams.set("acctType", accountTypeValue);
    }
    if (orderValue?.length > 0) {
      if (sortBy === "email") {
        updatedParams.set("orderEmail", orderValue);
        updatedParams.delete("order");
      } else {
        updatedParams.set("order", orderValue);
        updatedParams.delete("orderEmail");
      }
    } else {
      updatedParams.delete("order");
      updatedParams.delete("orderEmail");
    }
    if (checkoutStatus?.length > 0) {
      updatedParams.set("checkoutStatus", checkoutStatus);
    } else {
      updatedParams.set("checkoutStatus", "ALL");
    }
    updatedParams.set("clicked", "true");

    const gridContainer = document.querySelector(
      '[class*="gridContainer"]'
    )?.parentElement;
    if (gridContainer) {
      gridContainer.style.scrollBehavior = "auto";
      gridContainer.scrollLeft = 0;
    }

    setSearchParams(updatedParams);
    if (setShowFilter) {
      setShowFilter(false);
    }
    if (closeModal) {
      closeModal();
    }
  };
  return (
    <div>
      <div>
        <div className={styles.title}>Investor Transaction Radius</div>
        <div className={styles.radiusContainer}>
          <div
            className={`${styles.sliderContainer} ${
              isAllRadius ? styles.disabled : ""
            }`}
          >
            <SlicerC values={values} setValues={handleSliderChange} />
          </div>
          <div className={styles.radiusOptions}>
            <ButtonC
              type="button"
              label="All"
              size="small"
              className={`${styles.radiusBtn} ${
                isAllRadius ? styles.active : ""
              }`}
              onClick={handleAllRadiusClick}
            />
          </div>
        </div>
      </div>
      <div className={styles.view}>
        <FilterMobileOptions
          optionVacant={[
            {
              name: "MY ACCOUNTS",
              code: "MY ACCOUNTS"
            },
            {
              name: "ALL ACCOUNTS",
              code: "ALL ACCOUNTS"
            }
          ]}
          disabledOptions={
            showIEButton === "false" ? ["ALL ACCOUNTS"] : []
          }
          occupancy={myAccountValue}
          setOccupancy={setMyAccountValue}
          title={"View"}
          border={false}
        />
      </div>
      <div className={styles.view}>
        <FilterMobileOptions
          optionVacant={[
            {
              name: "FT VERIFIED",
              code: "FT VERIFIED"
            },
            {
              name: "PENDING APPROVAL",
              code: "PENDING APPROVAL"
            },
            {
              name: "ONBOARDED",
              code: "ONBOARDED"
            }
          ]}
          occupancy={accountTypeValue}
          setOccupancy={setAccountTypeValue}
          title={"Account Type"}
          border={true}
        />
      </div>
      <div className={styles.view}>
        <FilterMobileOptions
          optionVacant={[
            {
              name: "ALL",
              code: "ALL"
            },
            {
              name: "CHECKED OUT",
              code: "CHECKED OUT"
            },
            {
              name: "AVAILABLE",
              code: "AVAILABLE"
            }
          ]}
          occupancy={checkoutStatus}
          setOccupancy={setCheckoutStatus}
          title={"Investor Checkout Status"}
          border={true}
        />
      </div>
      {/* <div className={styles.SortSection}>
        <div className={styles.sortTitle}>Show Other Vaults</div>
        <FilterMobileOptions
          optionVacant={[
            {
              name: "OFF",
              code: "OFF"
            },
            {
              name: "ON",
              code: "ON"
            }
          ]}
          occupancy={showOtherVaults}
          setOccupancy={setShowOtherVaults}
          title={""}
          border={false}
        />
      </div> */}
      <div className={styles.SortSection}>
        <div className={styles.sortTitle}>Sort By</div>
        <FilterMobileOptions
          optionVacant={[
            {
              name: "Low to High",
              code: "Low to High"
            },
            {
              name: "High to Low",
              code: "High to Low"
            }
          ]}
          occupancy={sortBy === "interest" ? orderValue : ""}
          setOccupancy={(v: any) => {
            setSortBy("interest");
            setOrderValue(v);
          }}
          title={"Interest Score"}
          border={false}
        />
        <FilterMobileOptions
          optionVacant={[
            {
              name: "Low to High",
              code: "Low to High"
            },
            {
              name: "High to Low",
              code: "High to Low"
            }
          ]}
          occupancy={sortBy === "email" ? orderValue : ""}
          setOccupancy={(v: any) => {
            setSortBy("email");
            setOrderValue(v);
          }}
          title={"Email Score"}
          border={false}
        />
      </div>
      <ButtonC
        disabled={false}
        type="button"
        label={`See ${data?.totalRecords || 0} Investors`}
        size="large"
        className={styles.btn}
        onClick={() => handleApply()}
      />
    </div>
  );
}
